
import * as actionTypes from './actionTypes';

export const getNetworkThread = () => {
  return {
    type: actionTypes.GET_NETWORK_THREAD
  };
};

export const getNetworkThreadSuccess = (payload) => ({
  type: actionTypes.GET_NETWORK_THREAD_SUCCESS,
  payload
});

export const getNetworkThreadFail = () => ({
  type: actionTypes.GET_NETWORK_THREAD_FAIL
});

export const getNetworkThreadLoading = () => ({
  type: actionTypes.GET_NETWORK_THREAD_LOADING
});

export const resetNetworkThreadErrorSuccess = () => {
  return {
    type: actionTypes.RESET_NETWORK_THREAD_ERROR_SUCCESS
  }
}

export const toggleNetworkThread = (enabled) => ({
  type: actionTypes.TOGGLE_NETWORK_THREAD,
  payload: enabled
});

export const getThreadRadioStatus = () => ({
  type: actionTypes.GET_THREAD_RADIO_STATUS
});

export const getThreadRadioStatusSuccess = (payload) => ({
  type: actionTypes.GET_THREAD_RADIO_STATUS_SUCCESS,
  payload
});

export const getThreadRadioStatusFail = () => ({
  type: actionTypes.GET_THREAD_RADIO_STATUS_FAIL
});

export const getThreadRadioStatusLoading = () => ({
  type: actionTypes.GET_THREAD_RADIO_STATUS_LOADING
});

export const toggleNetworkThreadSuccess = (payload) => ({
  type: actionTypes.TOGGLE_NETWORK_THREAD_SUCCESS,
  payload
});

export const toggleNetworkThreadFail = (errorType) => ({
  type: actionTypes.TOGGLE_NETWORK_THREAD_FAIL,
  errorType
});

export const toggleNetworkThreadLoading = () => ({
  type: actionTypes.TOGGLE_NETWORK_THREAD_LOADING
});

export const threadInitialLoadFailed = () => ({
  type: actionTypes.THREAD_INITIAL_LOAD_FAILED
});



